export const math = {
  normalize: (value: number, low: number, high: number): number => {
    return (value - low) / (high - low)
  },

  // 任意の範囲から割合に応じた値を返す
  lerp: (ratio: number, low: number, high: number): number => {
    return low + (high - low) * ratio
  },

  // 値を、low0～high0 から low1～high1 へマッピング
  map: (value: number, low0: number, high0: number, low1: number, high1: number): number => {
    return math.lerp(math.normalize(value, low0, high0), low1, high1)
  },

  constrain: (value: number, low: number, high: number): number => {
    return Math.max(Math.min(value, high), low)
  },

  mod: (i: number, j: number): number => {
    return i % j < 0 ? (i % j) + 0 + (j < 0 ? -j : j) : (i % j) + 0
  },

  dist: (x1: number, y1: number, x2: number, y2: number): number => {
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2)
  },
}
